//router
// import IndexRouters from "./router/index"

//scss
import "./assets/scss/hope-ui.scss"
import "./assets/scss/custom.scss"
import "./assets/scss/dark.scss"
import "./assets/scss/rtl.scss"
import "./assets/scss/customizer.scss"

// Redux Selector / Action
import { useDispatch } from 'react-redux';

// import state selectors
import { setSetting } from './store/setting/actions'
import { userSignal } from "./signal/userSignal"
import Loader from "./components/Loader"
import { useEffect, useState } from "react"
import Spinners from "./views/uikit/spinner"
import { Spinner } from "react-bootstrap"
import { initSignal } from "./signal/initSignal"
import { useMutation, useQuery } from "react-query"
import axios from "axios"
import { DEV_SERVER } from "./constants/urls"
import { toast } from "react-toastify"
import { allUsersSignal } from "./signal/allUsersSignal"
import { confirmAlert } from "react-confirm-alert"
import 'react-confirm-alert/src/react-confirm-alert.css';
import { dealerSignal } from "./signal/dealerSignal"


function App({ children }) {

  const [loading, setLoading] = useState(true)

  const getAllUsers = useMutation(() => axios.get(`${DEV_SERVER}/auth/v2/employee/getEmployees`, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem("sauron-token")}`
    }
  }), {
    onSuccess: (data) => {
      let data1 = data.data

      let token = window.localStorage.getItem("sauron-token")
      let user = JSON.parse(atob(token.split('.')[1]))
      user = JSON.parse(user.user)
      if (data1.status) {
        let temp = {}
        data1.data.map((item) => {
          temp[item.id] = item
          if (item.id === user.id) {
            if (item.userType !== "manager") {
              toast.error("You are not authorized to login")
              window.localStorage.removeItem("sauron-token")
              if (window.location.pathname !== "/auth/sign-in") {
                window.location.href = "/auth/sign-in"
                setLoading(false)
              }
            }
            userSignal.value = { user: item, token: token }
          }
        })

        allUsersSignal.value = temp

        if (window.location.pathname === "/auth/sign-in") {
          window.location.href = "/dashboard"
        } else if (window.location.pathname === "/") {
          window.location.href = "/dashboard"
        }
        setLoading(false)

      } else {
        toast.error("Internal Server Error")
      }
    },

    onError: (error) => {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message)
      } else {
        toast.error(error.message)
      }

      confirmAlert({
        title: "Try Login Again",
        message: "Something went wrong",
        buttons: [
          {
            label: "Ok",
            onClick: () => {
              window.localStorage.removeItem("sauron-token")
              window.location.href = "/auth/sign-in"
            }
          },
          {
            label: "Cancel",
          }
        ]
      })
    }
  })

  const getDealer = useMutation(() => axios.get(`${DEV_SERVER}/dealer/v2`, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem("sauron-token")}`
    }
  }), {
    onSuccess: (data) => {
      let data1 = data.data
      if (data1.status) {
        let temp = {}
        data1.data.map((item) => {
          temp[item.id] = item
        })
        dealerSignal.value = temp
      } else {
      }
    }

  })



  // const getUser = useMutation((body) => axios.get(`${DEV_SERVER}/auth/v2/employee/${body.id}`, {
  //   headers: {
  //     Authorization: `Bearer ${body.token}`
  //   }
  // }), {
  //   onSuccess: (data) => {
  //     console.log("data ", data)
  //     let data1 = data.data
  //     let token = window.localStorage.getItem("sauron-token")
  //     if (data1.status) {
  //       userSignal.value = { user: data1?.data, token: token }
  //       if (window.location.pathname === "/auth/sign-in") {
  //         window.location.href = "/dashboard"
  //       } else if (window.location.pathname === "/") {
  //         window.location.href = "/dashboard"
  //       }
  //       setLoading(false)
  //     } else {
  //       toast.error("Internal Server Error")
  //     }
  //   },

  //   onError: (error) => {
  //     console.log("error ", error)
  //     if (error.response?.data?.message) {
  //       toast.error(error.response.data.message)
  //     } else {
  //       toast.error(error.message)
  //     }
  //   }
  // })

  // const GetUserDetails = (token) => {
  //   let user = JSON.parse(atob(token.split('.')[1]))
  //   user = JSON.parse(user.user)
  //   getUser.mutate({ id: user.id, token: token })
  // }


  useEffect(() => {

    if (userSignal.value === null) {
      let token = window.localStorage.getItem("sauron-token")
      if (token && token !== null && token !== undefined && token !== "" && token !== "undefined") {
        getAllUsers.mutate()
        getDealer.mutate()
      } else {
        if (window.location.pathname === "/auth/sign-in") {
          setLoading(false)
          // return
        } else {
          window.location.href = "/auth/sign-in"
          setLoading(false)
        }
      }
    } else {
      if (userSignal.value?.user?.userType !== "manager") {
        toast.error("You are not authorized to login")
        window.localStorage.removeItem("sauron-token")
        if (window.location.pathname !== "/auth/sign-in") {
          window.location.href = "/auth/sign-in"
          setLoading(false)
        }
      }
      if (window.location.pathname === "/auth/sign-in") {
        window.location.href = "/dashboard"
      } else if (window.location.pathname === "/") {
        window.location.href = "/dashboard"
      }
      setLoading(false)
    }
  }, [])

  const dispatch = useDispatch()
  dispatch(setSetting())
  return (
    <>
      {loading ? <div style={{ width: "100vw", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Spinner animation="grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div> :
        <div className="App">
          {/* <IndexRouters /> */}
          {children}

        </div>
      }
    </>
  );
}

export default App;
